/* 🤖 this file was generated by svg-to-ts */
export const iccIconMenu: {
  name: 'menu';
  data: string;
} = {
  name: 'menu',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 18h18v-2H3v2Zm0-5h18v-2H3v2Zm0-7v2h18V6H3Z" fill="currentColor"/></svg>`
};
